import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { adminInstance } from '../services/axiosInstance'; 
import { useNavigate } from 'react-router-dom';

const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const [apiError, setApiError] = React.useState('');
  const [successMsg, setSuccessMsg] = React.useState('');

  const initialValues = {
    OldPassword: '',
    newPassword: '',
    confirmPassword: '',
  };

  const validationSchema = Yup.object().shape({
    OldPassword: Yup.string().required('Current password is required'),
    newPassword: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .required('New password is required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword')], 'Passwords must match')
      .required('Confirm password is required'),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setApiError('');
    setSuccessMsg('');

    try {
      await adminInstance.post('ChangePassword', {
        OldPassword: values.OldPassword,
        NewPassword: values.newPassword,
      });

      setSuccessMsg('Password changed successfully.');
      resetForm();
    } catch (error) {
      console.error('Password change failed:', error);
      setApiError(error.response?.data?.message || 'Failed to change password');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="card aon-card">
        <div className="card-header aon-card-header">
            <h4>
                Change Password
            </h4>
        </div>
        <div className="card-body aon-card-body">
          <div className="container mt-4">
            <h4>Change Password</h4>

            {apiError && <Alert variant="danger">{apiError}</Alert>}
            {successMsg && <Alert variant="success">{successMsg}</Alert>}

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="OldPassword">
                        <Form.Label>Current Password</Form.Label>
                        <Form.Control
                          type="password"
                          name="OldPassword"
                          value={values.OldPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.OldPassword && !!errors.OldPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.OldPassword}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3" controlId="newPassword">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                          type="password"
                          name="newPassword"
                          value={values.newPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.newPassword && !!errors.newPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.newPassword}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3" controlId="confirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                          type="password"
                          name="confirmPassword"
                          value={values.confirmPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.confirmPassword && !!errors.confirmPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.confirmPassword}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Button type="submit" variant="primary" disabled={isSubmitting}>
                        {isSubmitting ? 'Saving...' : 'Change Password'}
                      </Button>{' '}
                      <Button variant="secondary" onClick={() => navigate(-1)}>Cancel</Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </div>
        </div>
    </div>
  );
};

export default ChangePasswordPage;
